import { useState } from "react";
import {
  AmazonItemsGetReportItemsCsvListPostRequest,
  AmazonItemsApi,
  ResponseGetReportItemsCsvListResponse,
  RequestGetReportItemsCsvListRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetReportItemsCsvList = () => {
  const [reportItemCsvList, setReportItemCsvList] =
    useState<ResponseGetReportItemsCsvListResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchReportItemCsvList = async (
    requestParams: RequestGetReportItemsCsvListRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonItemsGetReportItemsCsvListPostRequest = {
        req: requestParams,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsGetReportItemsCsvListPost(request);
      setReportItemCsvList(response);
      return response;
    } catch (err) {
      setError("アイテムCSVの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { reportItemCsvList, fetchReportItemCsvList, error, isLoading };
};
